import React, { ReactNode } from "react"

import { useBusinessTheme } from "Shared/hooks/useBusinessTheme"
import { useTenantDatePattern } from "Shared/hooks/useTenantDatePattern"

interface IBusinessThemeProviderProps {
  children: ReactNode
}

export const BusinessThemeProvider = ({ children }: IBusinessThemeProviderProps) => {
  useBusinessTheme()
  // Format de date de la langue (RTB-171). Pas de remontage forcé de l'arbre quand il change
  // (racine de l'app : on perdrait toute saisie en cours) — une grille déjà rendue se met à jour
  // à son prochain rendu, au pire à la navigation suivante.
  useTenantDatePattern()
  return <>{children}</>
}

export default BusinessThemeProvider
